// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"67":"8ef8b5af","95":"78884559"}[chunkId] + ".js";
};